import React, { useState, useCallback, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import BottomBar from '../components/BottomBar';
import CanvasArea from '../components/CanvasArea';
import { applyReportFilters, navigateToPage } from '../services/powerbiService';

const PAGES = [
  { id: 'overview',   label: 'Executive Overview'       },
  { id: 'sales',      label: 'Profitability Performance' },
  { id: 'geography',  label: 'Regional Breakdown'       },
];

// Default: full year 2020 (parent selected → all months included via drilldown logic)
const DEFAULT_FILTERS = {
  period:      { parents: ['2020'], children: {} },
  product:     { parents: [], children: {} },
  region:      { parents: [], children: {} },
  salesperson: [],
  periodType:  null,
};

const DashboardPage = () => {
  const reportRef = useRef(null);
  const [activePage, setActivePage] = useState('overview');
  const [activeTrigger, setActiveTrigger] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const currentPage = PAGES.find(p => p.id === activePage);

  const handleReportReady = useCallback((report) => {
    reportRef.current = report;
    applyReportFilters(report, filters);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleApplyFilters = useCallback((updatedFilters) => {
    console.log('🔄 Applying report-level filters:', updatedFilters);
    applyReportFilters(reportRef.current, updatedFilters);
  }, []);

  const handlePageChange = useCallback((pageId) => {
    setActivePage(pageId);
    const page = PAGES.find(p => p.id === pageId);
    if (page) navigateToPage(reportRef.current, page.label);
  }, []);

  return (
    <div className="dashboard-layout">
      <Sidebar
        pages={PAGES}
        activePage={activePage}
        onPageChange={handlePageChange}
        filters={filters}
        onFiltersChange={setFilters}
        activeTrigger={activeTrigger}
        onTriggerChange={setActiveTrigger}
        applyFilters={handleApplyFilters}
      />
      <div className="main-content">
        <TopBar currentPage={currentPage} />
        <CanvasArea
          currentPage={currentPage}
          filters={filters}
          onReportReady={handleReportReady}
        />
        <BottomBar currentPage={currentPage} />
      </div>
    </div>
  );
};

export default DashboardPage;
